import { InkTag } from "@/atoms"
import { CloudConnectionStatusCell } from "./CloudConnectionStatusCell"

import styles from "./StatusCell.module.scss"

import type { TFunction } from "@/hooks/useTranslation"
import type { StatusCellRecord } from "./StatusCell.types"

export const StatusCell = (t: TFunction) =>
  function StatusCellComponent(status: string, record?: StatusCellRecord) {
    if (!record?.connectionStatus)
      return (
        <div className={styles.container}>
          <InkTag
            dot
            className={styles.dot}
            color={`var(--status-${status.toLowerCase()})`}
          />
          <span>{status}</span>
        </div>
      )

    return (
      <CloudConnectionStatusCell
        status={record.connectionStatus}
        record={record}
        t={t}
      />
    )
  }
